import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { IPublishTermsService } from '../../redux/reducers';

export const selectServiceById = curry((serviceId: string, state: IAppState): IPublishTermsService => {
  const {
    publishTerms: { services },
  } = state;

  return services[serviceId];
});
